<template>
    <div class="customer-linked-accounts mb-4">
        <v-card>
            <v-card-title class="pt-2 pb-2"
            style="justify-content: space-between">
                <div>
                    {{ createHeadline(linkedAccounts.orderId) }}
                </div>
                <span style="flex: none !important; align-items: center" class="d-flex">
                    <v-text-field
                        v-if="linkedAccounts.atoms.length > 5"
                        label="Einträge durchsuchen"
                        hint="z.B. E-Mail, Name, SSO-ID, Produkt"
                        append-icon="mdi-magnify"
                        single-line
                        hide-details
                        :disabled="loading"
                        class="pt-0 mr-4"
                        clear-icon="mdi-close-cirle"
                        v-model="search"
                    />
                    <LinkAccountsBtn
                        class="mb-2"
                        :disabled="loading || calcUnassigned(linkedAccounts.atoms.length, linkedAccounts.totalCount) == 0"
                        :orderId="linkedAccounts.orderId"
                        :position="linkedAccounts.position"
                        :ssoId="ssoId" />
                </span>
            </v-card-title>
            <v-card-text class="pt-0">
                <div class="mb-2 mt-2 ml-3 d-flex">
                    <LabelValue class="pr-5 pt-2 pb-2" label="Verknüpft:" :value="linkedAccounts.atoms.length.toString()" />
                    <LabelValue class="pr-5 pt-2 pb-2" label="Verfügbar:" :value="calcUnassigned(linkedAccounts.atoms.length, linkedAccounts.totalCount).toString()" />
                    <LabelValue class="pr-5 pt-2 pb-2" label="Produkte:" :value="createProductString(linkedAccounts.products)" />
                </div>
                <h3 class="ml-3 mt-5">Konten:</h3>
                <v-data-table
                    hide-default-footer
                    :headers="headers"
                    :items="linkedAccounts.atoms"
                    :disable-pagination="true"
                    :loading="loading"
                    :search="search"
                >
                    <template slot="item" slot-scope="props">
                        <tr>
                            <td>{{ concatFullname(props.item.gender, props.item.firstName, props.item.lastName) }}</td>
                            <td>{{ props.item.email }}</td>
                            <td>{{ localeRegistrationTime(props.item.registrationTime) }}</td>
                            <td>{{ props.item.accountState }}</td>
                            <td>{{ localeLastLoginTime(props.item) }}</td>
                            <td>
                                <v-layout>
                                    <OpenCustomerBtn
                                        :ssoId="props.item.ssoId"
                                        :alternativeBtn="false"
                                        :disabled="loading"/>
                                    <CustomerEdit
                                            :disabled="loading"
                                            :alternativeBtn="false"
                                            :ssoId="props.item.ssoId"
                                        />
                                    <EditEmail
                                            :disabled="loading"
                                            :alternativeBtn="false"
                                            :ssoId="props.item.ssoId"
                                            @emailChanged="reload"
                                        />
                                    <div style="width: auto;">
                                        <ResetPassword
                                            :alternativeBtn="false"
                                            :ssoId="props.item.ssoId"
                                            :disabled="loading"
                                            class="customer-linked-accounts-reset-password_btn"
                                        />
                                    </div>
                                    <UnlinkAccountsBtn :disabled="loading" :ssoId="ssoId" :atomIds="props.item.atomIds"/>
                                </v-layout>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import UnlinkAccountsBtn from '@/components/customer/UnlinkAccountsBtn.vue';
import LinkAccountsBtn from '@/components/customer/LinkAccountsBtn.vue';
import EditEmail from '@/components/customer/EditEmail.vue';
import CustomerEdit from '@/components/customer/CustomerEdit.vue';
import LabelValue from '@/components/LabelValue.vue';
import OpenCustomerBtn from '@/components/customer/OpenCustomerBtn.vue';
import ResetPassword from '@/components/customer/ResetPassword.vue';

const DATE_OPTIONS = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
};

export default {
    name: 'LinkedAccountsList',
    props: ['linkedAccounts', 'loading', 'ssoId'],
    components: {
        UnlinkAccountsBtn,
        OpenCustomerBtn,
        ResetPassword,
        LinkAccountsBtn,
        LabelValue,
        EditEmail,
        CustomerEdit,
    },
    data() {
        return {
            search: '',
            about: 'Unterkonten sind ...',
            headers: [{
                text: 'Name',
                align: 'left',
                value: 'lastName',
                width: '20%',
            }, {
                text: 'E-Mailadresse',
                align: 'left',
                value: 'email',
                width: '20%',
            }, {
                text: 'Registriert am',
                align: 'left',
                value: 'registrationTime',
                width: '15%',
            }, {
                text: 'Nutzerstatus',
                align: 'left',
                value: 'accountState',
                width: '10%',
            }, {
                text: 'Letzter login',
                align: 'left',
                value: 'loginTime',
                width: '15%',
            }, {
                text: 'Aktionen',
                align: 'left',
                sortable: false,
                value: 'actions',
                width: '20%',
            }],
        };
    },
    methods: {
        concatFullname(gender, firstname, lastname) {
            return `${gender} ${firstname} ${lastname}`.trim().replace(/ {2,}/, '');
        },
        createHeadline(orderId) {
            return `Auftragsnummer: ${orderId}`;
        },
        calcUnassigned(atomCount, totalCount) {
            return totalCount - atomCount;
        },
        createProductString(products) {
            let productString = '';
            products.forEach((item, key) => {
                if (key > 0) {
                    productString += `, ${item.name} ${item.poart}`;
                } else {
                    productString += `${item.name} ${item.poart}`;
                }
            });
            return productString;
        },
        localeLastLoginTime(item) {
            if (!item.loginTime) {
                return 'noch kein Login';
            }
            const date = new Date(item.loginTime);
            return date.toLocaleString('de-DE', DATE_OPTIONS);
        },
        localeRegistrationTime(dateString) {
            const date = new Date(dateString);
            return date.toLocaleString('de-DE', DATE_OPTIONS);
        },
        reload() {
            this.$emit('dataChanged');
        },
    },
};

</script>

<style scoped lang="scss">
</style>
